import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LoadingSpinner from "@/components/ui/LoadingSpinner";
import { usePlatformAPI } from "@/api/PlatformProvider";
import { type APIError } from "@/api/APIError";
import { ErrorBox } from "@/components/ui/ErrorBox";
import { PartnerForm } from "./PartnerForm";

type Partner = {
    id: string;
    name: string;
    description?: string;
};

function EditPartnerPage() {
    const { id } = useParams<{ id: string }>();
    const api = usePlatformAPI();
    const navigate = useNavigate();
    const [partner, setPartner] = useState<Partner | null>(null);
    const [loadError, setLoadError] = useState<APIError | null>(null);

    useEffect(() => {
        api.get<Partner>(`api/partners/${id}`).then(([data, err]) => {
            if (err) { setLoadError(err); return; }
            setPartner(data);
        });
    }, [api, id]);

    return (
        <div className="flex flex-col gap-6">
            <div className="flex flex-row items-center gap-4">
                <button onClick={() => navigate("/partners")} className="text-grey hover:text-dark-dark-grey flex items-center gap-1">
                    <ArrowBackIcon fontSize="small" />
                </button>
                <h1 className="text-xl font-semibold">Edit Partner</h1>
            </div>
            {loadError && <ErrorBox error={loadError} />}
            {!loadError && !partner && (
                <div className="flex justify-center py-12">
                    <LoadingSpinner width={32} height={32} />
                </div>
            )}
            {partner && (
                <PartnerForm
                    initialName={partner.name}
                    initialDescription={partner.description ?? ""}
                    submitLabel="Save Changes"
                    onSubmit={async (name, description) => {
                        const [, err] = await api.put(`api/partners/${id}`, { name, description });
                        if (err) throw err;
                        navigate("/partners");
                    }}
                />
            )}
        </div>
    );
}

export default EditPartnerPage;
